export const LEGAL_VERSION = {
  privacy:  "2025-09-11",
  terms:    "2025-09-11",
  cookies:  "2025-09-11",
  disclaimer: "2025-09-11" // Descargo de responsabilidad
};

export const LEGAL_ROUTES = {
  privacy: "/legal/privacidad",
  terms: "/legal/terminos",
  cookies: "/legal/cookies",
  disclaimer: "/legal/descargo", // lo creamos abajo
};
